import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CancelScheduleModal from './CancelScheduleModal';

function mergeProps(stateProps, _, ownProps) {
  const { isRecurring, activeSchedule, cancelSchedule, ...restOwnProps } = ownProps;

  return {
    ...restOwnProps,
    isRecurring,
    activeSchedule,
    cancelSchedule: cancelSchedule.bind(null, activeSchedule, isRecurring),
  };
}

export default compose(connect(null, null, mergeProps), injectIntl)(CancelScheduleModal);
